import React, { useState, useEffect } from "react";
import { Modal, FloatingLabel, Form } from "react-bootstrap";
import LoadingButton from "./LoadingButton.js";
import { useGlobalContext } from "./GlobalContext.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
function ModalDocument({
  show,
  currentDocumentEdit,
  onHide,
  onValid,
  onCancel,
  accessType
}) {
  const {
    db,
    user,
    handleShowConfirmation,
    handleCloseConfirmation,
    getDateStrFromTimestamp
  } = useGlobalContext();
  const [title, setTitle] = useState(
    currentDocumentEdit ? currentDocumentEdit.title : ""
  );
  const [description, setDescription] = useState(
    currentDocumentEdit ? currentDocumentEdit.description : ""
  );
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState(null);
  const [urlDocument, setUrlDocument] = useState(null);

  useEffect(() => {
    if (show) {
      if (currentDocumentEdit) {
        setTitle(currentDocumentEdit.title || "");
        setDescription(currentDocumentEdit.description || "");
        setFileName(currentDocumentEdit.fileName || "");
        setFile(null);
        setUrlDocument(currentDocumentEdit.urlDocument || null);
      } else {
        setTitle("");
        setDescription("");
        setFileName("");
        setFile(null);
        setUrlDocument(null);
      }
    }
  }, [currentDocumentEdit, show, getDateStrFromTimestamp]);

  const handleAddDocument = async () => {
    try {
      const uid = "auto-generated" + Date.now();
      await db
        .addDocumentStorage(uid, file)
        .then(async (urlDoc) => {
          await db.addDocument({
            uid: uid,
            title,
            description,
            urlDocument: urlDoc,
            fileName: file.name,
            accessType
          });
        })
        .catch((error) => {
          console.error("Upload impossible : ", error);
        });
      onValid();
    } catch (error) {
      console.log("Error add document", error);
    }
  };

  const handleUpdateDocument = async () => {
    try {
      if (currentDocumentEdit.urlDocument === null && file !== null) {
        await db.addDocumentStorage(currentDocumentEdit.uid, file)
          .then(async (urlDoc) => {
            const obj = {
              title,
              description,
              urlDocument: urlDoc,
              fileName,
            }
            await db.updateDocument(currentDocumentEdit.uid, obj);
          })
      } else {
        const obj = {
          title,
          description,
        }
        await db.updateDocument(currentDocumentEdit.uid, obj);
      }
      onValid();
    } catch (error) {
      console.log("Error edit document", error);
    }
  };

  const handleRemoveDocument = async () => {
    try {
      db.deleteDocumentStorage(currentDocumentEdit)
        .then(async () => {
          await db.removeDocument(currentDocumentEdit.uid);
          currentDocumentEdit.urlDocument = null;
          setUrlDocument(null);
        });
    } catch (error) {
      console.log("Error Remove document", error);
    }
    onValid();
    handleCloseConfirmation();
  };

  const handleDocumentStorageDelete = async () => {
    await db.deleteDocumentStorage(currentDocumentEdit)
      .then(async () => {
        currentDocumentEdit.urlDocument = null;
        currentDocumentEdit.fileName = null;
        setUrlDocument(null);
        setFileName(null);
        handleCloseConfirmation();
      });
  };

  const handleDocumentChange = async (e) => {
    const file = e.target.files[0];
    if (file == null) return;
    try {
      setFile(file);
      setFileName(file.name);
    } catch (error) {
      console.log("Error DocumentChange", error);
    }
  };

  const manqueTitle = title === "";

  return (
    <Modal
      onHide={onHide}
      show={show}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          {currentDocumentEdit
            ? "Modification d'un document"
            : "Ajout d'un document"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>

          <div style={{ display: "flex", width: "100%", marginBottom: "20px", alignItems: "center", justifyContent: "flex-start" }}>

            {urlDocument === null ?
              <>
                <Form.Group controlId="formFile">
                  <Form.Label className="btn btn-custom1">
                    Sélectionner
                  </Form.Label>
                  <Form.Control
                    style={{ display: "none" }}
                    type="file"
                    onChange={handleDocumentChange}
                  />
                </Form.Group>

              </> :
              <LoadingButton
                className="btn btn-custom1"
                onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}
                onClickPromise={async () => {
                  handleShowConfirmation(
                    "Voulez-vous enlever le document ? ",
                    "Le titre et la description seront gardés",
                    "danger",
                    "Enlever",
                    "Annuler",
                    null,
                    handleDocumentStorageDelete
                  );
                }}
              >
                <FontAwesomeIcon
                  icon={faTimes}
                  style={{
                    fontSize: "1em",
                    marginRight: "5px",
                    color: "red",
                  }}
                />
                Supprimer le document
              </LoadingButton>
            }
            {fileName ?
              (<span style={{ fontWeight: "bold", fontSize: "0.8em" }}>{fileName}</span>)
              :
              <span style={{ color: "darkorange", textAlign: "center", marginRight: "5px", marginBottom: "5px", marginLeft: "5px" }}>Aucun document</span>
            }
          </div>

          {manqueTitle && <span style={{ color: "darkorange", textAlign: "center", marginRight: "5px", marginBottom: "5px", marginLeft: "5px" }}>Veuillez indiquer le titre</span>}
          <FloatingLabel
            label="Titre"
            className="mb-3"
            style={{ width: "100%" }}
          >
            <Form.Control
              type="text"
              style={{ width: "100%" }}
              autoComplete="on"
              value={title}
              required
              onChange={(e) => setTitle(e.target.value)}
              placeholder=""
            />
          </FloatingLabel>
          <div
            style={{ display: "flex", width: "100%", alignItems: "center", marginBottom: "5px" }}
          >
            <FloatingLabel controlId="floatingTextarea2" label="Description" style={{ flex: "1 1 auto" }}>
              <Form.Control
                className="mb-3"
                as="textarea"
                placeholder="Description"
                style={{ height: "150px" }}
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </FloatingLabel>
          </div>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
            }}
          >
            {currentDocumentEdit ? (
              <LoadingButton
                className="btn btn-custom5"
                disabled={user && currentDocumentEdit && user.uid === currentDocumentEdit.uid}
                onClick={() => {
                  handleShowConfirmation(
                    "Supprimer cet document ?",
                    "",
                    "danger",
                    "Supprimer",
                    "Annuler",
                    handleRemoveDocument
                  );
                }}
              >
                <FontAwesomeIcon
                  icon={faTimes}
                  style={{ fontSize: "1em", marginRight: "5px", color: "red" }}
                />
                Supprimer
              </LoadingButton>
            ) : null}
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
            }}
          >
            <LoadingButton className="btn btn-custom1" onClick={onCancel}>
              Annuler
            </LoadingButton>
            <LoadingButton
              className="btn btn-custom2"
              disabled={
                title === "" || (currentDocumentEdit === null && file === null)
              }
              onClickPromise={
                currentDocumentEdit ? handleUpdateDocument : handleAddDocument
              }
            >
              {currentDocumentEdit ? "Enregistrer" : "Ajouter"}
            </LoadingButton>
          </div>
        </div>
      </Modal.Footer>
    </Modal >
  );
}

export default ModalDocument;
